import { combineReducers } from '@ynap/reducer-utils'
import * as reducers from './reducers'

const countryReducer = combineReducers(reducers)

export default countryReducer
